/*
 * HollyDream™ product page — vanilla-JS port of the design component's logic.
 * Every computed style value below (colors, borders, shadows, transforms, timings,
 * easing curves, keyframes) is copied from the original component's render logic.
 * Prices / variant IDs come only from Shopify data injected by the section
 * (window.HollyDream[sectionId]); the cart is Shopify's real Ajax Cart API.
 */
(function () {
  'use strict';

  var reduced = !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The design used window.innerWidth < 760 for isMobile.
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 759.98px)') : { matches: window.innerWidth < 760 };

  var POLICY_TITLES = {
    refund: 'Refund Policy',
    shipping: 'Shipping Policy',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    contact: 'Contact Information'
  };

  function init(root) {
    if (root.__hdInit) return;
    var sid = root.getAttribute('data-hd-section');
    var D = (window.HollyDream || {})[sid];
    if (!D) return;
    root.__hdInit = true;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------------- Variant resolution (real Shopify variants) ---------------- */
    var variantMap = {};
    D.variants.forEach(function (v) { variantMap[v.id] = v; });
    function currentVariant() {
      var v = variantMap[D.variantId];
      if (!v) v = D.variants.filter(function (x) { return x.available; })[0] || D.variants[0];
      return v;
    }

    /* ---------------- State (same shape/defaults as the component) ---------------- */
    var S = {
      img: 0, tier: null, ship: null, warr: null, snip: 0,
      added: false, busy: false, error: false,
      isMobile: MQ.matches, pastHero: false, menuOpen: false, policy: null,
      curOpen: false, shownTotal: null, shownSave: null
    };
    var cartCountEl = $('[data-hd-cart-count]');
    var cartCount = cartCountEl ? parseInt(cartCountEl.textContent, 10) || 0 : 0;

    function fmt(cents) { return D.symbol + (cents / 100).toFixed(2); }

    // Same math as the design's calc(), in integer cents. Bundle price = unit × qty × (1 − discount).
    function calc() {
      var v = currentVariant();
      var unit = v ? v.price : 0;
      var cmpUnit = Math.max(v ? (v.compare_at_price || 0) : 0, unit);
      var tier = S.tier !== null ? S.tier : D.defaultTier;
      var ship = !!D.ship && (S.ship !== null ? S.ship : D.addonsOn);
      var warr = !!D.warr && (S.warr !== null ? S.warr : D.addonsOn);
      var tiers = D.tiers.map(function (t) {
        var price = Math.floor((unit * t.qty * (100 - t.disc) + 50) / 100);
        var compare = cmpUnit * t.qty;
        var save = Math.max(0, compare - price);
        var pct = compare > 0 ? Math.round((save / compare) * 100) : 0;
        return { qty: t.qty, popular: !!t.popular, price: price, compare: compare, save: save, pct: pct };
      });
      var cur = tiers[tier];
      var total = cur.price + (ship ? D.ship.price : 0) + (warr ? D.warr.price : 0);
      return { variant: v, tier: tier, ship: ship, warr: warr, tiers: tiers, cur: cur, total: total, save: cur.save };
    }

    /* ---------------- Count-up tween (design: 450ms, easeOutCubic) ---------------- */
    var raf = 0;
    var first = calc();
    var tgtTotal = first.total, tgtSave = first.save;
    function tween(a, b, c, d) {
      cancelAnimationFrame(raf);
      if (reduced) { S.shownTotal = b; S.shownSave = d; renderPrices(); return; }
      var t0 = performance.now(), Dur = 450;
      var step = function (now) {
        var k = Math.min(1, (now - t0) / Dur);
        var e = 1 - Math.pow(1 - k, 3);
        S.shownTotal = a + (b - a) * e;
        S.shownSave = c + (d - c) * e;
        renderPrices();
        if (k < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }

    /* ---------------- Main image animation (design: animateMain) ---------------- */
    var mainImg = $('[data-hd-main]');
    function animateMain(isFirst) {
      if (!mainImg || reduced || !mainImg.animate) return;
      mainImg.animate(isFirst
        ? [{ opacity: 0, transform: 'scale(1.08)' }, { opacity: 1, transform: 'scale(1)' }]
        : [{ opacity: 0.3, transform: 'scale(1.04)' }, { opacity: 1, transform: 'scale(1)' }],
        { duration: isFirst ? 900 : 450, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }

    /* ---------------- Render ---------------- */
    var tierEls = $$('[data-hd-tier]');
    function renderPrices() {
      var c = calc();
      var shownTotal = S.shownTotal !== null ? S.shownTotal : c.total;
      var shownSave = S.shownSave !== null ? S.shownSave : c.save;
      var el;
      if ((el = $('[data-hd-total]'))) el.textContent = fmt(shownTotal);
      if ((el = $('[data-hd-total-note]'))) el.textContent = '· you save ' + fmt(shownSave);
      if ((el = $('[data-hd-sticky-line]'))) el.textContent = 'Buy ' + c.cur.qty + ' · ' + fmt(shownTotal);
    }

    function render() {
      var c = calc();

      // Bundle tiers — same conditional values as the component's tiers.map()
      tierEls.forEach(function (card, i) {
        var t = c.tiers[i];
        var sel = i === c.tier;
        card.style.borderColor = sel ? '#1f6a36' : '#e3dfd7';
        card.style.background = sel ? '#f3f8f3' : '#fff';
        card.style.boxShadow = sel ? '0 8px 22px rgba(31,106,54,0.16)' : 'none';
        var btn = card.querySelector('[data-hd-tier-btn]');
        if (btn) btn.setAttribute('aria-checked', sel ? 'true' : 'false');
        var radio = card.querySelector('[data-hd-radio]');
        if (radio) radio.style.borderColor = sel ? '#1f6a36' : '#b5b1a8';
        var dot = card.querySelector('[data-hd-dot]');
        if (dot) dot.style.background = sel ? '#1f6a36' : 'transparent';
        var sl = card.querySelector('[data-hd-saveline]');
        if (sl) sl.textContent = 'You save ' + fmt(t.save) + ' (' + t.pct + '%)';
        var pr = card.querySelector('[data-hd-price]');
        if (pr) pr.textContent = fmt(t.price);
        var cp = card.querySelector('[data-hd-compare]');
        if (cp) cp.textContent = fmt(t.compare);
        var addons = card.querySelector('[data-hd-addons]');
        if (addons) addons.hidden = !sel;
        var sh = card.querySelector('[data-hd-ship]');
        if (sh) sh.checked = c.ship;
        var wa = card.querySelector('[data-hd-warr]');
        if (wa) wa.checked = c.warr;
      });

      // Collection card (single unit)
      var single = c.tiers[0], el;
      if ((el = $('[data-hd-single-pct]'))) el.textContent = single.pct;
      if ((el = $('[data-hd-single-price]'))) el.textContent = fmt(single.price);
      if ((el = $('[data-hd-single-compare]'))) el.textContent = fmt(single.compare);

      // Tween when the target total / savings change (componentDidUpdate)
      if (c.total !== tgtTotal || c.save !== tgtSave) {
        var fromT = S.shownTotal !== null ? S.shownTotal : tgtTotal;
        var fromS = S.shownSave !== null ? S.shownSave : tgtSave;
        tgtTotal = c.total; tgtSave = c.save;
        tween(fromT, c.total, fromS, c.save);
      }
      renderPrices();

      // Buy buttons (main + sticky share one state and one code path)
      var available = c.variant && c.variant.available;
      $$('[data-hd-buy-label]').forEach(function (l) {
        var txt = S.error ? 'TRY AGAIN' : (S.added ? l.getAttribute('data-added') : (available ? l.getAttribute('data-idle') : 'SOLD OUT'));
        if (l.textContent !== txt) l.textContent = txt;
      });

      // Gallery
      var n = D.gallery.length;
      $$('[data-hd-thumb]').forEach(function (b, i) {
        b.style.outline = '2px solid ' + (i === S.img ? '#1f6a36' : 'transparent');
        b.style.outlineOffset = '2px';
        b.style.opacity = i === S.img ? 1 : 0.72;
      });
      if (mainImg && n && mainImg.getAttribute('data-idx') !== String(S.img)) {
        var had = mainImg.hasAttribute('data-idx');
        mainImg.setAttribute('data-idx', String(S.img));
        if (had) {
          mainImg.src = D.gallery[S.img].src;
          mainImg.alt = D.gallery[S.img].alt;
          animateMain(false);
        }
      }

      // Rotating review snippets
      $$('[data-hd-snip]').forEach(function (s, i) { s.hidden = i !== S.snip; });
      $$('[data-hd-dotbtn]').forEach(function (b, i) {
        var dot = b.firstElementChild;
        if (dot) dot.style.background = i === S.snip ? '#1f6a36' : '#cfcac0';
      });

      // Menu / currency
      var nav = $('[data-hd-mobile-nav]');
      if (nav) nav.hidden = !(S.menuOpen && S.isMobile);
      $$('[data-hd-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', S.menuOpen ? 'true' : 'false'); });
      $$('[data-hd-cur-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', S.curOpen ? 'true' : 'false'); });
      var dd = $('[data-hd-cur-dropdown]');
      if (dd) dd.hidden = !(S.curOpen && !S.isMobile);
      var sheet = $('[data-hd-cur-sheet]');
      if (sheet) sheet.hidden = !(S.curOpen && S.isMobile);

      // Cart badge
      if (cartCountEl) {
        cartCountEl.textContent = cartCount;
        cartCountEl.hidden = !(cartCount > 0);
      }

      // Sticky quick-buy bar
      var sticky = $('[data-hd-sticky]');
      if (sticky) {
        var on = S.pastHero;
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.style.transform = on ? 'translateY(0)' : 'translateY(110%)';
        sticky.style.visibility = on ? 'visible' : 'hidden';
      }

      // Policy modal
      var modal = $('[data-hd-policy-modal]');
      if (modal) {
        modal.hidden = !S.policy;
        var title = POLICY_TITLES[S.policy] || '';
        modal.setAttribute('aria-label', title);
        var h = modal.querySelector('[data-hd-policy-title]');
        if (h) h.textContent = title;
        $$('[data-hd-pol]').forEach(function (p) { p.hidden = p.getAttribute('data-hd-pol') !== S.policy; });
      }
    }

    function set(patch) {
      for (var k in patch) S[k] = patch[k];
      render();
    }

    /* ---------------- Accordions + FAQ (same values as panel()) ---------------- */
    $$('[data-hd-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var chev = btn.lastElementChild;
        if (chev) chev.style.transform = open ? 'rotate(180deg)' : 'none';
        var panel = btn.nextElementSibling;
        if (panel) {
          panel.setAttribute('aria-hidden', open ? 'false' : 'true');
          panel.style.gridTemplateRows = open ? '1fr' : '0fr';
          panel.style.visibility = open ? 'visible' : 'hidden';
          var inner = panel.firstElementChild;
          if (inner) inner.style.opacity = open ? 1 : 0;
        }
      });
    });

    /* ---------------- Bundle tiers + add-ons ---------------- */
    tierEls.forEach(function (card, i) {
      var btn = card.querySelector('[data-hd-tier-btn]');
      if (btn) btn.addEventListener('click', function () {
        if (card.animate && !reduced) {
          card.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.97)' }, { transform: 'scale(1.015)' }, { transform: 'scale(1)' }],
            { duration: 380, easing: 'ease-out' });
        }
        set({ tier: i });
      });
      var sh = card.querySelector('[data-hd-ship]');
      if (sh) sh.addEventListener('change', function () { set({ ship: sh.checked }); });
      var wa = card.querySelector('[data-hd-warr]');
      if (wa) wa.addEventListener('change', function () { set({ warr: wa.checked }); });
    });

    /* ---------------- Add to cart (Shopify Ajax Cart API) ---------------- */
    var addedT = 0;
    function onBuy() {
      if (S.busy) return;
      var c = calc();
      var v = c.variant;
      if (!v || !v.available) return;
      var items = [{ id: v.id, quantity: c.cur.qty }];
      if (c.ship && D.ship) items.push({ id: D.ship.id, quantity: 1 });
      if (c.warr && D.warr) items.push({ id: D.warr.id, quantity: 1 });
      S.busy = true;
      clearTimeout(addedT);
      fetch(D.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Could not add to cart');
            return fetch(D.routes.cart, { headers: { 'Accept': 'application/json' } });
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartCount = cart.item_count;
          set({ added: true, error: false, busy: false });
          if (D.afterAdd === 'checkout') {
            addedT = setTimeout(function () { window.location.href = D.routes.checkout; }, 700);
          } else if (D.afterAdd === 'cart') {
            addedT = setTimeout(function () { window.location.href = D.routes.cartPage; }, 700);
          } else {
            addedT = setTimeout(function () { set({ added: false }); }, 2200);
          }
        })
        .catch(function (err) {
          if (window.console) console.warn('[HollyDream] add to cart failed:', err && err.message);
          set({ error: true, added: false, busy: false });
          addedT = setTimeout(function () { set({ error: false }); }, 2200);
        });
    }
    $$('[data-hd-buy]').forEach(function (b) { b.addEventListener('click', onBuy); });
    // Returning from checkout via the back button restores the page from bfcache — reset button state.
    window.addEventListener('pageshow', function (e) { if (e.persisted) set({ added: false, busy: false, error: false }); });

    /* ---------------- Gallery ---------------- */
    var n = D.gallery.length;
    var prev = $('[data-hd-prev]'), next = $('[data-hd-next]');
    if (prev) prev.addEventListener('click', function () { set({ img: (S.img - 1 + n) % n }); });
    if (next) next.addEventListener('click', function () { set({ img: (S.img + 1) % n }); });
    $$('[data-hd-thumb]').forEach(function (b, i) { b.addEventListener('click', function () { set({ img: i }); }); });
    var swipe = $('[data-hd-swipe]'), tx = 0, ty = 0;
    if (swipe) {
      swipe.addEventListener('touchstart', function (e) { var t = e.touches[0]; tx = t.clientX; ty = t.clientY; }, { passive: true });
      swipe.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        var dx = t.clientX - tx, dy = t.clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          set({ img: dx < 0 ? (S.img + 1) % n : (S.img - 1 + n) % n });
        }
      }, { passive: true });
    }

    /* ---------------- Review snippets (auto-rotate every 6s) ---------------- */
    var timer = setInterval(function () { set({ snip: (S.snip + 1) % 3 }); }, 6000);
    $$('[data-hd-dotbtn]').forEach(function (b, i) {
      b.addEventListener('click', function () { clearInterval(timer); set({ snip: i }); });
    });

    /* ---------------- Header: menu, currency, links ---------------- */
    $$('[data-hd-menu-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { set({ menuOpen: !S.menuOpen }); });
    });
    $$('[data-hd-menu-close]').forEach(function (a) {
      a.addEventListener('click', function () { set({ menuOpen: !S.menuOpen }); });
    });
    $$('[data-hd-cur-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { set({ curOpen: !S.curOpen, menuOpen: false }); });
    });
    var locForm = root.querySelector('form.hd-loc-form') || document.getElementById('HollyDreamCurrencyForm');
    $$('[data-hd-country]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-hd-code');
        var country = b.getAttribute('data-hd-country');
        if (code === D.currency || !locForm || !country) { set({ curOpen: false }); return; }
        var input = locForm.querySelector('input[name="country_code"]');
        if (input) input.value = country;
        set({ curOpen: false });
        locForm.submit();
      });
    });
    $$('[data-hd-href]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = b.getAttribute('data-hd-href'); });
    });
    var toTop = $('[data-hd-totop]');
    if (toTop) toTop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    /* ---------------- Policy modal ---------------- */
    $$('[data-hd-policy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e) e.preventDefault();
        set({ policy: a.getAttribute('data-hd-policy'), menuOpen: false });
      });
    });
    var modal = $('[data-hd-policy-modal]');
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) set({ policy: null }); });
    var close = $('[data-hd-policy-close]');
    if (close) close.addEventListener('click', function () { set({ policy: null }); });

    /* ---------------- Global listeners (componentDidMount) ---------------- */
    var hero = $('[data-hd-hero]');
    var onScroll = function () {
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : false;
      if (past !== S.pastHero) set({ pastHero: past });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    var onMQ = function () {
      var m = MQ.matches;
      if (m !== S.isMobile) set({ isMobile: m, menuOpen: false, curOpen: false });
    };
    if (MQ.addEventListener) MQ.addEventListener('change', onMQ);
    else if (MQ.addListener) MQ.addListener(onMQ);
    window.addEventListener('resize', onMQ);
    document.addEventListener('pointerdown', function (e) {
      if (S.curOpen && !(e.target.closest && e.target.closest('[data-cur]'))) set({ curOpen: false });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && (S.curOpen || S.policy)) set({ curOpen: false, policy: null });
    });

    /* ---------------- Scroll reveal (design: setupReveal) ---------------- */
    function setupReveal() {
      if (reduced || !('IntersectionObserver' in window)) return;
      var vh = window.innerHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          io.unobserve(el);
          if (el.__hdHold) { el.__hdHold.cancel(); el.__hdHold = null; }
          var pop = el.dataset.reveal === 'pop';
          el.animate(pop
            ? [{ opacity: 0, transform: 'scale(0.6)' }, { opacity: 1, transform: 'scale(1.06)', offset: 0.7 }, { opacity: 1, transform: 'scale(1)' }]
            : [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: pop ? 520 : 560, delay: Number(el.dataset.delay) || 0, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      $$('[data-reveal]').forEach(function (el) {
        if (!el.animate || el.getBoundingClientRect().top < vh * 0.92) return;
        el.__hdHold = el.animate([{ opacity: 0 }, { opacity: 0 }], { duration: 1, fill: 'forwards' });
        io.observe(el);
      });
    }

    /* ---------------- Review marquees (design: setupMarquee) ---------------- */
    function setupMarquee(track, dir, speed) {
      if (!track || track.dataset.mq) return null;
      track.dataset.mq = '1';
      var wrap = track.parentElement;
      if (reduced || !track.animate) { wrap.style.overflowX = 'auto'; return null; }
      var orig = Array.prototype.slice.call(track.children);
      if (!orig.length) return null;
      var firstEl = orig[0];
      var addSet = function () {
        orig.forEach(function (el) {
          var k = el.cloneNode(true);
          k.setAttribute('aria-hidden', 'true');
          k.removeAttribute('data-shopify-editor-block');
          k.querySelectorAll('a,button').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
          track.appendChild(k);
        });
      };
      addSet();
      var setW = track.children[orig.length].offsetLeft - firstEl.offsetLeft;
      if (!(setW > 0)) return null;
      var copies = Math.ceil((wrap.clientWidth * 2) / setW);
      for (var i = 1; i < copies; i++) addSet();
      var kf = dir < 0
        ? [{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-setW) + 'px)' }]
        : [{ transform: 'translateX(' + (-setW) + 'px)' }, { transform: 'translateX(0)' }];
      var anim = track.animate(kf, { duration: (setW / speed) * 1000, iterations: Infinity });
      var pause = function () { anim.pause(); };
      var play = function () { anim.play(); };
      ['pointerdown', 'mouseenter'].forEach(function (ev) { wrap.addEventListener(ev, pause); });
      ['pointerup', 'pointercancel', 'pointerleave', 'mouseleave'].forEach(function (ev) { wrap.addEventListener(ev, play); });
      wrap.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      return anim;
    }

    /* ---------------- Mount ---------------- */
    if (mainImg) mainImg.setAttribute('data-idx', '0');
    render();
    onScroll();
    animateMain(true);
    requestAnimationFrame(setupReveal);
    setTimeout(function () {
      $$('[data-hd-marquee]').forEach(function (track) {
        setupMarquee(track, Number(track.getAttribute('data-hd-marquee')), Number(track.getAttribute('data-hd-speed')));
      });
    }, 300);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.hd-root[data-hd-section]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', boot);
})();
